export default __webpack_public_path__ + "static/media/cookdeck_UF.b5b6288e.png";